import {useEffect, useMemo, useState} from 'react';

import {autorun} from 'mobx';

import type {Props} from './types';

import {isDestructible} from '../../../../utils/store';
import {getAsyncEventStore} from './getAsyncEventStore';
import {getEventContexts} from './getEventContexts';
import {getEventData} from './getEventData';

export const useController = ({event}: Props) => {
  const contexts = useMemo(() => getEventContexts(event), [event]);
  const staticData = useMemo(
    () => getEventData(event, contexts),
    [event, contexts],
  );

  const [data, setData] = useState(staticData);

  useEffect(() => {
    const store = getAsyncEventStore(event, contexts, staticData);

    if (store) {
      const disposer = autorun(() => {
        setData(store.data);
      });

      return () => {
        disposer();

        if (isDestructible(store)) {
          store.destruct();
        }
      };
    }
  }, [event, contexts, staticData]);

  return {contexts, data};
};
